@if (errors && plainErrorMessages().length > 0) {
  <ul class="errorList mb-2 pl-5">
    @for (error of plainErrorMessages(); track error) {
      <li>
        @if (error.summary) {
          <div class="summary" [innerHTML]="error.summary"></div>
        }
        @if (error.detail) {
          <div class="detail" [innerHTML]="error.detail"></div>
        }
      </li>
    }
  </ul>
}
@if (errors && conflictingTimetableEntries().length > 0) {
  <div>
    <p>Folgende Veranstaltung(en) stehen im Konflikt:</p>
    <table style="margin-top: 1ex" class="table table-striped">
      <tr>
        <th>Dozierende</th>
        <th>Titel</th>
      </tr>
      @for (te of conflictingTimetableEntries(); track te) {
        <tr>
          <td>{{te.host}}</td>
          <td>{{te.title}}</td>
        </tr>
      }
    </table>
  </div>
}
